"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Auth = void 0;
const Client_1 = require("../resources/auth/client/Client");
const Client_2 = require("../resources/idToken/client/Client");
const Client_3 = require("../resources/customToken/client/Client");
const Client_4 = require("../resources/sessionCookie/client/Client");
const Client_5 = require("../resources/userProfile/client/Client");
const Client_6 = require("../resources/saml/client/Client");
class Auth {
    constructor(_options) {
        this._options = _options;
    }
    get auth() {
        var _a;
        return ((_a = this._auth) !== null && _a !== void 0 ? _a : (this._auth = new Client_1.Auth(this._options)));
    }
    get idToken() {
        var _a;
        return ((_a = this._idToken) !== null && _a !== void 0 ? _a : (this._idToken = new Client_2.IdToken(this._options)));
    }
    get customToken() {
        var _a;
        return ((_a = this._customToken) !== null && _a !== void 0 ? _a : (this._customToken = new Client_3.CustomToken(this._options)));
    }
    get sessionCookie() {
        var _a;
        return ((_a = this._sessionCookie) !== null && _a !== void 0 ? _a : (this._sessionCookie = new Client_4.SessionCookie(this._options)));
    }
    get userProfile() {
        var _a;
        return ((_a = this._userProfile) !== null && _a !== void 0 ? _a : (this._userProfile = new Client_5.UserProfile(this._options)));
    }
    get saml() {
        var _a;
        return ((_a = this._saml) !== null && _a !== void 0 ? _a : (this._saml = new Client_6.Saml(this._options)));
    }
}
exports.Auth = Auth;
